export const MODAL_PARAMS = Object.freeze({
    modalContentStyles: { padding: 0 },
    withoutCloseIcon: true,
    settings: { maskClosable: false }
});
